module.exports = __webpack_public_path__ + "media/images/riders/VALENTINA_HOLL-bb4982057db93180c0345e73aea644d1.png";